"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledIcon = styled_components_1.default.i `
  color: inherit;
  font-size: 18px;
  margin-right: 12px;
`;
